import { ActionTree } from "vuex";
import { LogActionsTypes, LogMutationsTypes } from "./types";
import { Log, LogActions, LogState } from "./interface";
import Client from "@/plugins/axios/axios";
import { Response_ } from "@/plugins/axios/response";

export const actions: ActionTree<LogState, LogState> & LogActions = {
  [LogActionsTypes.LIST_LOG]: async ({ commit }): Promise<number> => {
    return Client.get<number, Response_>(`log/list`)
      .then((response: Response_) => {
        commit(LogMutationsTypes.SET_LOG, response.body as Array<Log>);
        return response.status;
      })
      .catch((err) => err);
  }
};
